import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "../store/index";
Vue.use(VueI18n);

const messages = {
  vi: {
    titleHeader: "Đặt sân",
    titleMenuArea: "Chọn theo khu vực",
    titleHotDeal: "Giá tốt",
    titleTop10: "Top 10 sân tốt",
    login: "Đăng nhập",
    logout: "Đăng xuất",
    hotDealTitle1: "Đặt ngay tee time giá tốt",
    hotDealTitle2: "Giá tốt hôm nay",
    titleTop10Page: "Top 10 sân golf tốt nhất tuần",
    descPageHome: "NHANH CHÓNG - TIỆN LỢI - DỄ DÀNG",
    aboutUs: "Về chúng tôi",
    contact: "Liên hệ",
    downloadApp: "Tải app WGHN",
    support: "Cần hỗ trợ đặt sân,",
    PBX: "TỔNG ĐÀI 0247.100.1088 SẴN SÀNG PHỤC VỤ 24/7",
    viewMore: "Xem thêm",
    numberHolesText: "Số hố",
    history: "Lịch sử",
    titleContact: "Liên hệ với chúng tôi",
    titleAboutUs: "Giới thiệu về VGS Booking",
    hole: "hố",
    searchBtn: "TÌM KIẾM",
    infoCourse: "Thông tin sân",
    evaluate: "Đánh giá",
    areaNorthern: "Sân golf tốt khu vực miền Bắc",
    areaSouth: "Sân golf tốt khu vực miền Nam",
    areaCentral: "Sân golf tốt khu vực miền Trung",
    expired: "Mã đã hết hạn",
    search: "TÌM TEE TIME",
    overTeeTime: "Đã hết Tee Time",
    date: "ngày",
    courseTee: "Tee time sân",
    bookNowBtn: "ĐẶT NGAY",
    price: "Giá",
    from: "Từ",
    morning: "Sáng",
    afternoon: "Chiều",
    lightHour: "Giờ đèn",
    descTee: "Bao gồm: Green Fee & Caddie Fee & 1/2 Buggy",
    addUser: "Thêm người",
    total: "Tổng",
    addUserTee: "Thêm người chơi vào Tee Time",
    listUser: "Danh sách người chơi",
    confirm: "Xác nhận",
    comingSoon: "Ứng dụng đang phát triển",
    notiSendOtp:
      "Quý khách chưa có tài khoản tại VGS Booking (WGHN). Vui lòng nhập mã OTP vừa được VGS Booking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác nhận đồng ý mở tài khoản và đồng ý với Điều kiện điều khoản mở tài khoản tại VGS Booking (WGHN).",
    subSendOtp: "Vui lòng nhập OTP được gửi về số điện thoại của bạn",
    notiSendOtpVGS:
      "Vui lòng nhập mã OTP vừa được VGS Booking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác thực đăng nhập vào tài khoản của Quý khách tại VGS Booking (WGHN)",
    fullName: "Họ và tên",
    noData: "Không có dữ liệu",
    userVga: "Người chơi có mã vID",
    userOutSystem: "Người chơi ngoài hệ thống",
    note:
      "Lưu ý: Gói BH 20.000.000 VNĐ là khuyến mãi tặng kèm cho tất cả các booking qua VGS Booking",
    unConfirm: "Chưa xác nhận",
    pay: "Thanh toán",
    paymentGuide: "Hướng dẫn thanh toán",
    bank: "Ngân hàng",
    content: "Nội dung",
    numberCard: " Số tài khoản",
    amountMoney: "Số tiền",
    accountHolder: "Chủ tài khoản",
    scanQr: "Quét mã QR bằng ứng dụng WGHN",
    unPay: "Chưa thanh toán",
    paid: "Đã thanh toán",
    BookingCode: "Mã đặt chỗ",
    userBooking: "Người Booking",
    companyName: "Công ty CP Dịch Vụ Đặt Sân Golf Việt Nam",
    orPay: "Hoặc trả cho từng người",
    payNow: "Thanh toán ngay",
    notify: "Thông báo",
    next: "Tiếp",
    skip: "BỎ QUA",
    waitOtpText: "Vui lòng đợi xác nhận OTP",
    enteredOTPConfirmBooking:
      "Quý khách vui lòng nhập mã OTP vừa được VGS Booking (WGHN) gửi qua SMS đến Số điện thoại của Quý khách để xác nhận giao dịch",
    notiPaymentIn30Minute:
      "Thông tin đặt sân đã được ghi nhận, Quý khách vui lòng chờ VGS Booking (WGHN) xác nhận và sẽ thông báo tới Quý khách. Vui lòng thanh toán trong vòng 30 phút kể từ khi nhận được thông báo xác nhận.",
    enterOtp: "Vui lòng nhập mã xác nhận vào ô dưới đây",
    notiSuccess:
      "Đặt sân thành công! Vui lòng đợi nhân viên xác nhận booking của bạn.",
    textBookingCourse: "Bạn có chắc chắn muốn đặt sân",
    terrain: "Địa hình sân",
    buyMore: "Mua thêm",
    codeBooking: "Mã Booking",
    bannerContent:
      "Đặt sân, mua sắm, du lịch golf và vô vàn dịch vụ tiện ích khác!",
    bannerSubContent: "Tải app WGHN ngay!",
    bookCourse: "Đặt sân",
    shopping: "Mua sắm",
    for: "cho",
    people: "người",
    at: "vào lúc"
  },
  en: {
    login: "Login",
    logout: "Logout",
    titleHeader: "Set the pitch",
    titleMenuArea: "Choose by area",
    titleHotDeal: "Hot Deal",
    titleTop10: "Top 10 good yards",
    hotDealTitle1: "Book now good price tee time",
    hotDealTitle2: "Hot deal today",
    titleTop10Page: "Top 10 best golf courses of the week",
    descPageHome: "FAST - CONVENIENT - EASY",
    aboutUs: "About us",
    contact: "Contact",
    downloadApp: "Download app WGHN",
    support: "Need help with pitching,",
    PBX: "PBX 0247.100.1088 READY TO SERVE 24/7",
    viewMore: "See more",
    numberHolesText: "Number of holes",
    history: "History",
    titleContact: "Contact us",
    titleAboutUs: "About VGS Booking",
    hole: "holes",
    inputDate: "Input date",
    searchBtn: "Search",
    infoCourse: "Course info",
    evaluate: "Evaluate",
    areaNorthern: "Good golf course in the North",
    areaSouth: "Good golf course in the South",
    areaCentral: "Good golf course in the Central region",
    expired: "Code has expired",
    search: "FIND TEE TIME",
    overTeeTime: "Tee time is over",
    date: "date",
    courseTee: "Yard tee time",
    bookNowBtn: "BOOK NOW",
    price: "Price",
    from: "From",
    morning: "Morning",
    afternoon: "Afternoon",
    lightHour: "Light hour",
    descTee: "Includes: Green Fee & Caddy Fee & 1/2 Buggy",
    addUser: "More people",
    total: "Total",
    addUserTee: "Add players to Tee Time",
    listUser: "List of players",
    confirm: "Confirm",
    comingSoon: "Coming soon",
    notiSendOtp:
      "You do not have an account at VGS Booking (WGHN). Please enter the OTP code just sent by VGS Booking (WGHN) via SMS to your phone number to confirm your agreement to open an account and agree to the Terms and Conditions of account opening at VGS Booking (WGHN).",
    subSendOtp: "Please enter the OTP sent to your phone number",
    notiSendOtpVGS:
      "Please enter the OTP code that has just been sent by VGS Booking (WGHN) via SMS to your phone number to verify your account login at VGS Booking (WGHN).",
    fullName: "First and last name",
    noData: "No data",
    userVga: "Player with vID code",
    userOutSystem: "Players outside the system",
    note:
      "Note: The insurance package of VND 20,000,000 is a bonus for all bookings via VGS Booking",
    unConfirm: "Unconfimred",
    pay: "Pay",
    paymentGuide: "Payment Guide",
    bank: "Bank",
    content: "Content",
    numberCard: "Account number",
    amountMoney: "Amount of money",
    accountHolder: "Account holder",
    scanQr: "Scan QR code with WGHN . app",
    unPay: "Unpaid",
    paid: "Paid",
    BookingCode: "Booking code",
    userBooking: "Person Booking",
    companyName: "Vietnam Golf Course Booking Service Joint Stock Company",
    orPay: "Or pay per person",
    payNow: "Pay now",
    notify: "Notify",
    next: "Next",
    skip: "SKIP",
    waitOtpText: "Please wait for OTP confirmation",
    enterOtp: "Please enter the confirmation code in the box below",
    enteredOTPConfirmBooking:
      "Please enter the OTP code just sent by VGS Booking (WGHN) via SMS to your phone number to confirm the transaction.",
    notiPaymentIn30Minute:
      "The booking information has been recorded, please wait for VGS Booking (WGHN) to confirm and notify you. Please pay within 30 minutes of receiving the confirmation message.",
    notiSuccess:
      "Placement successful! Please wait for the staff to confirm your booking.",
    textBookingCourse: "Are you sure you want to book the pitch",
    terrain: "Terrain of the field",
    buyMore: "Buy More",
    codeBooking: "Booking Code",
    bannerContent:
      "Course booking, shopping, golf travel and countless other convenient services!",
    bannerSubContent: "Download the WGHN app now!",
    bookCourse: "Booking course",
    shopping: "Shopping",
    for: "for",
    people: "people",
    at: "at"
  },
  th: {
    titleHeader: "ตั้งสนาม",
    titleMenuArea: "เลือกตามภูมิภาค",
    titleHotDeal: "ราคาดี",
    titleTop10: "10 อันดับสนามที่ดี",
    login: "เข้าสู่ระบบ",
    logout: "ออกจากระบบ",
    hotDealTitle1: "จองเวลาออกรอบด้วยราคาที่ดี",
    hotDealTitle2: "ราคาดีวันนี้",
    titleTop10Page: "10 อันดับสนามกอล์ฟที่ดีที่สุดประจำสัปดาห์",
    descPageHome: "รวดเร็ว สะดวก ง่าย",
    aboutUs: "เกี่ยวกับเรา",
    contact: "ติดต่อ",
    downloadApp: "ดาวน์โหลดแอพ WGHN",
    support: "ต้องการความช่วยเหลือในการจองลาน,",
    PBX: "PBX 0247.100.1088 พร้อมให้บริการทุกวันตลอด 24 ชั่วโมง",
    viewMore: "ดูเพิ่มเติม",
    numberHolesText: "จำนวนหลุม",
    history: "ประวัติศาสตร์",
    titleContact: "ติดต่อเรา",
    titleAboutUs: "เกี่ยวกับการจอง VGS",
    hole: "จำนวนหลุม",
    searchBtn: "ค้นหา",
    infoCourse: "ข้อมูลสนาม",
    evaluate: "ประเมิน",
    areaNorthern: "สนามกอล์ฟที่ดีในภาคเหนือ",
    areaSouth: "สนามกอล์ฟที่ดีในภาคใต้",
    areaCentral: "สนามกอล์ฟที่ดีในภาคกลาง",
    expired: "รหัสหมดอายุแล้ว",
    search: "หาเวลาออกรอบ",
    overTeeTime: "เวลาออกรอบสิ้นสุดลงแล้ว",
    date: "วัน",
    courseTee: "เวลาทีสนาม",
    bookNowBtn: "จองตอนนี้",
    price: "ราคา",
    from: "มาจาก",
    morning: "ส่องแสง",
    afternoon: "ตอนบ่าย",
    lightHour: "ชั่วโมงแสง",
    descTee: "รวม: กรีนฟี & แคดดี้ & 1/2 Buggy",
    addUser: "ผู้คนมากขึ้น",
    total: "ทั้งหมด",
    addUserTee: "เพิ่มผู้เล่นใน Tee Time",
    listUser: "รายชื่อผู้เล่น",
    confirm: "ยืนยัน",
    fullName: "ชื่อและนามสกุล",
    noData: "ไม่มีข้อมูล",
    userVga: "เครื่องเล่นที่มีรหัส vID",
    userOutSystem: "ผู้เล่นที่อยู่นอกระบบ",
    note:
      "หมายเหตุ: แพ็คเกจประกันมูลค่า VND 20,000,000 เป็นโบนัสสำหรับการจองทั้งหมดผ่าน VGS Booking",
    unConfirm: "ไม่ได้รับการยืนยัน",
    pay: "จ่าย",
    paymentGuide: "คู่มือการชำระเงิน",
    bank: "ธนาคาร",
    content: "เนื้อหา",
    numberCard: "หมายเลขบัญชี",
    amountMoney: "จำนวนเงิน",
    accountHolder: "ผู้ถือบัญชี",
    scanQr: "สแกนคิวอาร์โค้ดด้วยแอป WGHN",
    unPay: "ค้างชำระ",
    paid: "จ่าย",
    BookingCode: "รหัสการจอง",
    userBooking: "การจองบุคคล",
    companyName: "บริการจองสนามกอล์ฟเวียดนาม บริษัทร่วมทุน",
    orPay: "หรือเหมาจ่ายต่อคน",
    payNow: "จ่ายตอนนี้",
    notify: "แจ้ง",
    next: "ต่อไป",
    skip: "ข้าม",
    waitOtpText: "กรุณารอการยืนยัน OTP",
    enterOtp: "กรุณากรอกรหัสยืนยันในช่องด้านล่าง",
    notiSuccess: "ตำแหน่งสำเร็จ! กรุณารอเจ้าหน้าที่ยืนยันการจอง",
    textBookingCourse: "คุณแน่ใจหรือไม่ว่าต้องการจองสนาม",
    terrain: "ภูมิประเทศของสนาม",
    buyMore: "ซื้อเพิ่ม",
    codeBooking: "รหัสการจอง",
    bannerContent:
      "จองคอร์ส ช้อปปิ้ง ทัวร์กอล์ฟ และบริการอำนวยความสะดวกอื่นๆ อีกนับไม่ถ้วน!",
    bannerSubContent: "ดาวน์โหลดแอป WGHN เลย!",
    bookCourse: "จองสนามกอล์ฟ",
    shopping: "ช้อปปิ้ง",
    for: "ให้",
    people: "คน",
    at: "ที่"
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "vi", // set locale
  fallbackLng: "vi", // set fallback locale
  messages // set locale messages,
});

export default i18n;
